import React from "react";
import { Typography } from "@mui/material";
import { PageLayout } from "../../components/PageLayout/PageLayout";
import { NOT_FOUND_TEXT } from "../shared/constants";
import { NotFoundContainer } from "../shared/styledComponents";

const NotFoundPage: React.FC = () => {
  return (
    <PageLayout>
      <NotFoundContainer>
        <Typography variant="h4" component="h1">
          {NOT_FOUND_TEXT}
        </Typography>
      </NotFoundContainer>
    </PageLayout>
  );
};

export default NotFoundPage;
